module.exports = __webpack_public_path__ + "static/media/kanchanpur1.31e9d93a.ogg";